export const typesOpcionesPagoCompra = {
    contado: 'contado',
    msi: 'msi',
    credito: 'credito'
};